import { usePermissionRequest } from '@dealstack/frontend/shared/components/PermissionWrapper/PermissionWrapper';
import { TableRowActionsMenu } from '@dealstack/frontend/shared/components/TableRowActionsMenu/TableRowActionsMenu';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import {
	PermissionRole,
	ResourceType,
} from '@dealstack/shared/lib/common/fineGrainedAuthorization/permissions';
import { useMemo } from 'react';
import { TableRowActionOption } from '@dealstack/frontend/shared/components/TableRowActionsMenu/TableRowActionsMenu.types';

interface Props {
	isPending: boolean;
	mipId: string;
	onMessageClick: () => void;
	onRevokeClick: () => void;
}

export const InvestmentRowActions = ({
	isPending,
	mipId,
	onMessageClick,
	onRevokeClick,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const { hasPermission: hasAdminPermission } = usePermissionRequest({
		resourceType: ResourceType.PROGRAMME,
		resourceId: mipId,
		permissionRole: PermissionRole.ADMIN,
	});

	const options: TableRowActionOption[] = useMemo(() => {
		const items: TableRowActionOption[] = [
			{
				label: tMipManage('investors.view_messages'),
				onClick: onMessageClick,
			},
		];

		if (isPending && hasAdminPermission) {
			items.push({
				label: tMipManage('investors.expanded_row.revoke'),
				onClick: onRevokeClick,
			});
		}

		return items;
	}, [tMipManage, isPending, hasAdminPermission, onMessageClick, onRevokeClick]);

	return <TableRowActionsMenu options={options} />;
};
